/**
 * The Start popup's two names: validation, whether Continue may run, and the body sent to Start and
 * Start over. Names are trimmed everywhere, and the limits are the contract's (the service enforces
 * the same ones).
 */
import { OPERATOR_NAME_MAX, SIGNATORY_NAME_MAX, type StartBody } from './api/contract';

export type NameValues = { operator: string; signatory: string };
export type NameErrorCode = 'required' | 'too_long';
export type NameErrors = { operator?: NameErrorCode; signatory?: NameErrorCode };

const nameError = (value: string, max: number): NameErrorCode | undefined => {
  const name = value.trim();
  if (name === '') return 'required';
  return name.length > max ? 'too_long' : undefined;
};

/** Trimmed; required when empty; too_long over the limit. The signatory only when its field shows. */
export const validateNames = (values: NameValues, signatoryShown: boolean): NameErrors => {
  const errors: NameErrors = {};
  const operator = nameError(values.operator, OPERATOR_NAME_MAX);
  if (operator) errors.operator = operator;
  if (signatoryShown) {
    const signatory = nameError(values.signatory, SIGNATORY_NAME_MAX);
    if (signatory) errors.signatory = signatory;
  }
  return errors;
};

export const canContinue = (errors: NameErrors): boolean =>
  errors.operator === undefined && errors.signatory === undefined;

/** Trimmed names; `signatory_name` is '' when the field is hidden (the operator signs). */
export const startBody = (values: NameValues, signatoryShown: boolean, language: string): StartBody => ({
  operator_name: values.operator.trim(),
  signatory_name: signatoryShown ? values.signatory.trim() : '',
  language,
});
